import { useEffect } from "react";

import { useFormikContext } from "formik";

import { useBillableOperationsQuery } from "@sso/apis/billableOperations";
import { useAppSelector } from "@sso/hooks/useRedux";
import { selectSoftwareLicenceId } from "@sso/store/slices/softwareLicence";
import { LicenceType, SoftwareLicenceFormValues } from "@sso/types";
import { Typography } from "@sso/ui/Typography";

import PricingRulesRangeForm from "./pricingRules";

const ApiPricingForm = () => {
  const softwareId = useAppSelector(selectSoftwareLicenceId);
  const { data } = useBillableOperationsQuery(softwareId);
  const { setFieldValue, values, errors } = useFormikContext<SoftwareLicenceFormValues>();

  useEffect(() => {
    if (!data) {
      return;
    }

    if (!values.pricingRules || !values.pricingRules.length) {
      const defaultRules = data.map(billableOperation => {
        return {
          billableOperationId: billableOperation.billableOperationId,
          pricingRules: [
            {
              minRange: 1,
              billableOperationId: billableOperation.billableOperationId,
              isLast: false,
            },
          ],
        };
      });
      setFieldValue("apiPricingRules", defaultRules);
    } else {
      const defaultRules = data.map(billableOperation => {
        const pricingRules = values.pricingRules
          ?.filter(x => x.billableOperationId === billableOperation.billableOperationId)
          .sort((a, b) => a.minRange! - b.minRange!);

        return {
          billableOperationId: billableOperation.billableOperationId,
          pricingRules: pricingRules ?? [],
        };
      });

      setFieldValue("apiPricingRules", defaultRules);
    }
  }, [data]);

  return (
    <>
      {values.apiPricingRules?.map((apiRule, index) => {
        const e = errors?.apiPricingRules?.[index];
        const err = e ? (e as any).pricingRules : null;
        return (
          <div key={index}>
            <Typography margin="0.5rem 0">
              {data?.find(x => x.billableOperationId === apiRule.billableOperationId)?.description}
            </Typography>
            <PricingRulesRangeForm
              fieldAccessor={`apiPricingRules[${index}].pricingRules`}
              rules={apiRule.pricingRules ?? []}
              licenceType={LicenceType.API}
              errors={err}
            />
          </div>
        );
      })}
    </>
  );
};

export default ApiPricingForm;
